export default __webpack_public_path__ + "static/media/custom1.9f577043.png";